<template>  
    <div class="main-menu" v-if="show_menu" role="menu">
        <div class="main-menu-content" role="none">            
            <div class="main-menu-logo-text" role="none" aria-hidden="true"  >
                <div class="main-menu-logo-text-content" v-text="TT('mainmenu.textlogo')"></div>
            </div>
            <router-link to="/grant-list" v-text="getText('menu.grants')" role="menuitem"  />            
            <a href="#" @click.prevent="logout" v-text="getText('menu.logout')" role="menuitem" class="logout-control"/>
        </div>
    </div>
    <router-view />    
</template>

<style lang="scss">
    #app {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        .main-menu {
            height: 3em;
            max-height: 3em;
            min-height: 3em;
            border-bottom: 1px solid black;
            .main-menu-content {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: nowrap;
                padding: 0 1em;
                .main-menu-logo-text {
                    height: 100%;
                    margin-right: 1em;
                    .main-menu-logo-text-content {
                        height: 100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        font-weight: bold;
                        font-size: 1.25em;
                    }
                }
                a {
                    margin-right: 1em;
                    color: black;
                    height: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                }




                .main-menu-expandable-item {
                    height: 100%;
                    position: relative;
                    margin-right: 1em;
                    .main-menu-expandable-item-text {
                        height: 100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        text-decoration: underline;
                        cursor: pointer;
                    }
                    .main-menu-expandable-list {
                        display: none;
                        position: absolute;
                        top: 100%;
                        background: white;
                        padding: 0 .75em 0.75em .75em;
                        box-shadow: 3px 3px 10px silver;
                        z-index: 3;
                        width: auto;
                        a {
                            display: block;
                            width: auto;
                            white-space: nowrap;
                            height: 2em;
                            max-height: 2em;
                            min-height: 2em;
                        }
                    }

                    &:hover{
                        .main-menu-expandable-list {
                            display: block;
                        }
                    }

                }
            }
        }
    }

</style>
<script>
    import {central_data} from '@/lib/vendor/eve/central-data';
    import U from '@/lib/vendor/eve/lib-utils';
    import miText from '@/mixins/text-ops';
    export default{
        name: 'app-main',
        data: function () {
            return{
                show_menu: false,
                isAdminUser: false
            };
        },
        mixins:[miText],
        methods: {
            check_login: function () {
                if (U.IntMoreOr(central_data().jwtMonitor.get_payload('id'), 0, null)) {
                    this.$data.show_menu = true;
                    this.$data.isAdminUser = central_data().jwtMonitor.userRoleIs('admin');
                } else {
                    this.$data.show_menu = false;
                    this.$data.isAdminUser = false;
                }
            },
            logout: function () {
                central_data().jwtMonitor.clear_token();
                location.reload(true);
            }
        },
        created: function () {
            central_data().jwtMonitor.on(this, this.check_login);
        },
        unmounted: function () {
            central_data().jwtMonitor.off(this, this.check_login);
        },
        mounted: function () {
            this.check_login();
        }

    }
</script>